export default __webpack_public_path__ + "static/media/xtreme-project-5.26936bfc.jpg";